import type { NotificationMessageListFilters, NotificationMessageView } from "../types";

export const notificationCenterQueryRoot = ["notification-center"] as const;
export const notificationCenterDefaultPageSize = 10;

/** 构造顶栏消息汇总查询键。 */
export function notificationMessageSummaryQueryKey() {
  return [...notificationCenterQueryRoot, "summary"] as const;
}

/** 构造包含视图和分页的消息列表查询键。 */
export function notificationMessageListQueryKey(filters: NotificationMessageListFilters) {
  return [
    ...notificationCenterQueryRoot,
    "messages",
    filters.view,
    filters.page,
    filters.pageSize,
  ] as const;
}

/** 返回各消息视图的中文标题。 */
export function notificationViewLabel(view: NotificationMessageView): string {
  if (view === "action") return "待处理";
  if (view === "notice") return "普通通知";
  return "全部消息";
}
